import axios from './HTTP'

export default {
  create (params, callback, errorCallback) {
    axios
      .post(`/api/coordinated_coverage_requests.json`, {
        coordinated_coverage_request: params }
      )
      .then(response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  get (id, callback, errorCallback) {
    axios
      .get(`/api/coordinated_coverage_requests/${ id }.json`)
      .then( response => {
        callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  accept (id, callback, errorCallback) {
    axios
      .patch(`/api/coordinated_coverage_requests/${ id }/accept.json`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  reject (id, callback, errorCallback) {
    axios
      .patch(`/api/coordinated_coverage_requests/${ id }/reject.json`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  cancel (id, callback, errorCallback) {
    axios
      .patch(`/api/coordinated_coverage_requests/${ id }/cancel.json`)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },


}
